import dayjs from 'dayjs';

/**
 * 格式化时间戳（秒|毫秒）
 * @param {timestamp} value
 */
const timeFilter = (value) => {
    value = value.toString();
    if (value === '0') {
        return '-'
    }
    if (value) {
        if (value.length === 13) {
            return dayjs(Number(value)).format('YYYY-MM-DD HH:mm:ss');
        }
        return dayjs.unix(Number(value)).format('YYYY-MM-DD HH:mm:ss');
    } else {
        return '-';
    }
};

const timeStamp = (StatusMinute) => {
    var day = parseInt(StatusMinute / 60 / 24);
    var hour = parseInt((StatusMinute / 60) % 24);
    var min = parseInt(StatusMinute % 60);
    StatusMinute = '';
    if (day > 0) {
        StatusMinute = day + '天';
    }
    if (hour > 0) {
        StatusMinute += hour + '小时';
    }
    if (min > 0) {
        StatusMinute += parseFloat(min) + '分钟';
    }
    return StatusMinute || '-';
};

const alarmLevelFilter = (value) => {
    const LEVEL_MAP = {
        100: '一般',
        200: '严重',
        300: '致命'
    };
    return LEVEL_MAP[value] || '-'
};

const alarmLevelTagFilter = (value) => {
    const LEVEL_MAP = {
        100: '',
        200: 'warning',
        300: 'danger'
    };
    return LEVEL_MAP[value] || '-'
};

const alarmStatusFilter = (value) => {
    const LEVEL_MAP = {
        0: '初始化',
        1: '告警中',
        2: '已消警'
    };
    return LEVEL_MAP[value] || '-'
};



export default {
    timeFilter,
    timeStamp,
    alarmLevelFilter,
    alarmLevelTagFilter,
    alarmStatusFilter
};
